import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Range } from '../../common/core/range.js';
import { isUpperAsciiLetter, isLowerAsciiLetter } from '../../../base/common/strings.js';
export var WordSelectionRangeProvider = /*#__PURE__*/function () {
  function WordSelectionRangeProvider() {
    _classCallCheck(this, WordSelectionRangeProvider);
  }

  _createClass(WordSelectionRangeProvider, [{
    key: "provideSelectionRanges",
    value: function provideSelectionRanges(model, positions) {
      var result = [];

      var _iterator = _createForOfIteratorHelper(positions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var position = _step.value;
          var bucket = [];
          result.push(bucket);

          this._addInWordRanges(bucket, model, position);

          this._addWordRanges(bucket, model, position);

          this._addWhitespaceLine(bucket, model, position);

          bucket.push({
            range: model.getFullModelRange()
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "_addInWordRanges",
    value: function _addInWordRanges(bucket, model, pos) {
      var obj = model.getWordAtPosition(pos);

      if (!obj) {
        return;
      }

      var word = obj.word,
          startColumn = obj.startColumn;
      var offset = pos.column - startColumn;
      var start = offset;
      var end = offset;
      var lastCh = 0; // LEFT anchor (start)

      for (; start >= 0; start--) {
        var ch = word.charCodeAt(start);

        if (start !== offset && (ch === 95
        /* Underline */
        || ch === 45
        /* Dash */
        )) {
          // foo-bar OR foo_bar
          break;
        } else if (isLowerAsciiLetter(ch) && isUpperAsciiLetter(lastCh)) {
          // fooBar
          break;
        }

        lastCh = ch;
      }

      start += 1; // RIGHT anchor (end)

      for (; end < word.length; end++) {
        var _ch = word.charCodeAt(end);

        if (isUpperAsciiLetter(_ch) && isLowerAsciiLetter(lastCh)) {
          // fooBar
          break;
        } else if (_ch === 95
        /* Underline */
        || _ch === 45
        /* Dash */
        ) {
          // foo-bar OR foo_bar
          break;
        }

        lastCh = _ch;
      }

      if (start < end) {
        bucket.push({
          range: new Range(pos.lineNumber, startColumn + start, pos.lineNumber, startColumn + end)
        });
      }
    }
  }, {
    key: "_addWordRanges",
    value: function _addWordRanges(bucket, model, pos) {
      var word = model.getWordAtPosition(pos);

      if (word) {
        bucket.push({
          range: new Range(pos.lineNumber, word.startColumn, pos.lineNumber, word.endColumn)
        });
      }
    }
  }, {
    key: "_addWhitespaceLine",
    value: function _addWhitespaceLine(bucket, model, pos) {
      if (model.getLineLength(pos.lineNumber) > 0 && model.getLineFirstNonWhitespaceColumn(pos.lineNumber) === 0 && model.getLineLastNonWhitespaceColumn(pos.lineNumber) === 0) {
        bucket.push({
          range: new Range(pos.lineNumber, 1, pos.lineNumber, model.getLineMaxColumn(pos.lineNumber))
        });
      }
    }
  }]);

  return WordSelectionRangeProvider;
}();